/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-unresolved */
import * as yup from "yup";
import moment from "moment";
// import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { partners, VariableConstants } from "src/config/constant";
import { GeneralDetails, PRODUCT_ID } from "../interfaces";
import regex from "../../../regex";
import { calcAgeFromToday } from "../resources";
import { products } from "../../resources";

const proportionateLife = {
  nameOfProportionateLife: "",
  proprtionateDob: "",
  proprtionatePercent: "",
  proprtionateGender: ""
};

const initialValues: GeneralDetails = {
  title: "",
  titleCode: "",
  otherTitle: "",
  gender: "",
  genderCode: "",
  firstName: "",
  middleName: "",
  lastName: "",
  dob: "",
  maritalStatus: "",
  maritalStatusCode: "",
  nationality: "",
  countryOfResidence: "",
  countryOfResidenceCode: "",
  cityOfResidence: "",
  dateOfLastEntry: "",
  educationQualification: "",
  educationQualificationCode: "",
  mobileNo: "",
  email: "",
  occupation: "",
  occupationCode: "",
  nameOfOrganization: "",
  subOccupation: "",
  subOccupationCode: "",
  designation: "",
  annualIncome: "",
  panNo: "",
  natureOfWork: "",
  relationship: "Self",
  isJointJourney: false,
  jointDob: "",
  jointFirstName: "",
  jointMiddleName: "",
  jointLastName: "",
  jointMobileNo: "",
  jointPan: "",
  jointAnnualIncome: "",
  jointGender: "",
  isProportionateLife: false,
  primaryProportionatePercent: "",
  primarySumAssured: "",
  totalLoanAmountOpted: "",
  proportionate: Array(1).fill(proportionateLife),
  UIDNo: "",
  electronicAccount: "",
  eiaNumber: "",
  // jointRelationship: "",
  // jointRelationshipCode: "",
  telePhoneNo: "",
  jointTelePhoneNo: "",
  requirementFlag: false,
  businessOwner: false,
  housewifeFlag: false
};

const validationSchema = (partnerId: any, productId: any, salutations: any, mefSchema?: any) => {
  let isProportionate: boolean;
  return yup.object().shape<Record<keyof GeneralDetails, yup.AnySchema>>({
    // title: yup.string().trim().required("Title is Required"),
    title: yup.string().when([], (_, schema) =>
      mefSchema?.title?.required
        ? schema
            .trim()
            .required("Title is Required")
            .test({
              name: "custom-validation",
              message: "Invalid title for selected gender",
              test(value) {
                const { genderCode } = this.parent;
                const validSalutations =
                  genderCode && salutations[genderCode]
                    ? salutations[genderCode].map(
                        (item: { label: string; value: string }) => item.label
                      )
                    : [];
                if (!validSalutations.includes(value)) {
                  throw new yup.ValidationError("Title is Required", value, "title");
                }
                return true;
              }
            })
        : schema.notRequired()
    ),
    otherTitle: yup
      .string()
      .when(["title", "mefSchema"], ([title, mefSchema], schema) =>
        title === "Others" && mefSchema?.otherTitle?.required
          ? schema.trim().required("Title is Required")
          : schema.trim().notRequired()
      ),
    gender: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.gender?.required
          ? schema.trim().required("Gender is Required")
          : schema.notRequired()
      ),
    genderCode: yup.string(),
    firstName: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.firstName?.required
          ? schema
              .required("First Name is Required")
              .matches(regex.nomineefullNamewithDot, "Invalid First Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema.notRequired()
      ),
    middleName: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.middleName?.required
          ? schema
              .matches(regex.nomineefullNamewithDot, "Invalid Middle Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema
              .matches(regex.nomineefullNamewithDot, "Invalid Middle Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
              .notRequired()
      ),
    lastName: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.lastName?.required
          ? schema
              .matches(regex.nomineefullNamewithDot, "Invalid Last Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema
              .matches(regex.nomineefullNamewithDot, "Invalid Last Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
              .notRequired()
      ),
    dob: yup.string().when([], (_, schema) =>
      mefSchema?.dob?.required
        ? schema
            .required("DOB is Required")
            .test("length", "Invalid DOB", (value) => {
              const age = calcAgeFromToday(value);
              if (productId === PRODUCT_ID.GCS) {
                return age >= 15 && age < 66 && value?.length === 10;
              }
              const maxAge = partnerId === partners.JIO ? 60 : 65;
              if (age >= 18 && age <= maxAge && value.length === 10) return true;
              return false;
            })
            .test("is-valid-date", "Invalid DOB", (value) => moment(value, "DD/MM/YYYY").isValid())
            .default("")
        : schema
            .test("length", "Invalid DOB", (value) => {
              const age = calcAgeFromToday(value!);
              if (productId === PRODUCT_ID.GCS) {
                return age >= 15 && age < 66 && value?.length === 10;
              }
              const maxAge = partnerId === partners.JIO ? 60 : 65;
              if (age >= 18 && age <= maxAge && value?.length === 10) return true;
              return false;
            })
            .test("is-valid-date", "Invalid DOB", (value) => moment(value, "DD/MM/YYYY").isValid())
            .default("")
            .notRequired()
    ),
    maritalStatus: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.maritalStatus?.required
          ? schema.required("Marital Status is Required")
          : schema.notRequired()
      ),
    nationality: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.nationality?.required
          ? schema.required("Nationality is Required")
          : schema.notRequired()
      ),
    nationalityCode: yup.string(),
    countryOfResidence: yup
      .string()
      .when(["nationality", "mefSchema"], ([nationality], schema) =>
        nationality && nationality !== "Indian" && mefSchema?.countryOfResidence?.required
          ? schema.required("Country Of Residence is Required")
          : schema.trim().notRequired()
      ),
    countryOfResidenceCode: yup.string(),
    cityOfResidence: yup
      .string()
      .when(["nationality", "mefSchema"], ([nationality], schema) =>
        nationality && nationality !== "Indian" && mefSchema?.cityOfResidence?.required
          ? schema
              .required("City Of Residence is Required")
              .matches(regex.fullName, "Invalid Values")
              .max(60, "Max 60 characters Required")
          : schema.trim().notRequired()
      ),
    dateOfLastEntry: yup.string().when(["nationality"], ([nationality], schema) =>
      nationality && nationality !== "Indian" && mefSchema?.dateOfLastEntry?.required
        ? schema
            .required("Date Of Last Entry is Required")
            .max(10, "Invalid Date")
            .test(
              "is-valid-date-after-dob",
              "Invalid date",
              (value, { parent }) =>
                !moment(value, "DD/MM/YYYY").isBefore(moment(parent.dob, "DD/MM/YYYY"))
            )
            .test("is-valid-date", "Invalid date", (value) =>
              moment(value, "DD/MM/YYYY").isSameOrBefore(new Date())
            )
        : schema.trim().notRequired()
    ),
    mobileNo: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.mobileNo?.required
          ? schema
              .required("Mobile Number is Required")
              .matches(regex.numeric, "Invalid Mobile Number")
              .min(10, "Min 10 digits allowed")
              .max(16, "Max 16 digits allowed")
          : schema.notRequired()
      ),
    educationQualification: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.educationQualification?.required
          ? schema.required("Educational Qualification is Required")
          : schema.notRequired()
      ),
    email: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.email?.required
          ? schema
              .required("Email is Required")
              .matches(regex.email, "Invalid Email")
              .max(60, "Max 60 value required")
          : schema
              .matches(regex.email, "Invalid Email")
              .max(60, "Max 60 value required")
              .notRequired()
      ),
    occupation: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.occupation?.required
          ? schema.required("Occupation is Required")
          : schema.notRequired()
      ),
    subOccupation: yup
      .string()
      .when(["occupationCode", "mefSchema"], ([occupationCode, mefSchema], schema) =>
        ["OT"].includes(occupationCode) && mefSchema?.subOccupation?.required
          ? schema.trim().required("Sub Occupation is Required")
          : schema.trim().notRequired()
      ),
    nameOfOrganization: yup
      .string()
      .when("occupationCode", ([occupationCode], schema) =>
        !(partners.JIO === partnerId && ["SE", ""].includes(occupationCode!)) &&
        mefSchema.nameOfOrganization.required
          ? schema
              .required("Name Of Organization is Required")
              .matches(regex.nameOfOrganizationRestriction, "Invalid Values")
              .min(3, "Min 3 Character Allowed")
              .max(40, "Max 40 Character Allowed")
          : schema.notRequired()
      ),
    // nameOfOrganization: yup
    //   .string()
    //   .required(" Name Of Organization is Required")
    //   .matches(regex.nameOfOrganizationRestriction, "Invalid Values")
    //   .min(3, "Min 3 Character Allowed")
    //   .max(40, "Max 40 Character Allowed"),
    designation: yup
      .string()
      .when(["occupationCode"], ([occupationCode], schema) =>
        !["SE", "OT", ""].includes(occupationCode) && mefSchema?.designation?.required
          ? schema
              .required("Designation is Required")
              .matches(regex.alphaNumericWithRestriction, "Invalid Values")
              .max(60, "Max 60 Character Allowed")
          : schema.notRequired()
      ),
    annualIncome: yup.string().when("occupationCode", {
      is: (occupationCode: string) => occupationCode === "HW",
      then: (schema) =>
        schema
          .matches(regex.digits, "Invalid Annual Income")
          .max(10, "Max 10 digits allowed")
          .notRequired(),
      otherwise: (schema) =>
        mefSchema?.annualIncome?.required
          ? schema
              .required("Annual Income is Required")
              .matches(regex.digits, "Invalid Annual Income")
              .max(10, "Max 10 digits allowed")
          : schema
              .matches(regex.digits, "Invalid Annual Income")
              .max(10, "Max 10 digits allowed")
              .notRequired()
    }),
    panNo: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.panNo?.required
          ? schema
              .required("PAN is Required")
              .matches(regex.pancard, "Invalid PAN")
              .max(10, "Max 10 values allowed")
          : schema
              .matches(regex.pancard, "Invalid PAN")
              .max(10, "Max 10 values allowed")
              .notRequired()
      ),
    natureOfWork: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.natureOfWork?.required
          ? schema.required("Nature Of Work is Required")
          : schema.notRequired()
      ),
    titleCode: yup.string(),
    maritalStatusCode: yup.string(),
    educationQualificationCode: yup.string(),
    occupationCode: yup.string(),
    subOccupationCode: yup.string(),
    relationship: yup.string(),
    UIDNo: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.UIDNo?.required
          ? schema.min(12, "Min 12 digits allowed").max(12, "Max 12 digits allowed")
          : schema.notRequired()
      ),
    electronicAccount: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.electronicAccount?.required && [PRODUCT_ID.GHS].includes(productId!)
          ? schema.required("Electronic Account is Required")
          : schema.notRequired()
      ),
    eiaNumber: yup
      .string()
      .when(["electronicAccount"], ([electronicAccount], schema) =>
        electronicAccount === "Yes" && mefSchema?.eiaNumber?.required
          ? schema
              .required("EIA Number is Required")
              .matches(regex.numeric, "Invalid EIA Number")
              .max(13, "Max 13 digits allowed")
          : schema.notRequired()
      ),
    isJointJourney: yup.boolean(),
    jointFirstName: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointFirstName?.required
          ? schema
              .required("First Name is Required")
              .matches(regex.nomineefullNamewithDot, "Invalid First Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema
              .matches(regex.nomineefullNamewithDot, "Invalid First Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
              .notRequired()
      ),
    jointMiddleName: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointMiddleName?.required
          ? schema
              .matches(regex.nomineefullNamewithDot, "Invalid Middle Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema
              .matches(regex.nomineefullNamewithDot, "Invalid Middle Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
              .notRequired()
      ),
    jointLastName: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointLastName?.required
          ? schema
              .matches(regex.nomineefullNamewithDot, "Invalid Last Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
          : schema
              .matches(regex.nomineefullNamewithDot, "Invalid Last Name")
              .min(1, "Min 1 characters Required")
              .max(60, "Max 60 characters Required")
              .notRequired()
      ),
    jointDob: yup.string().when(["isJointJourney"], ([isJointJourney], schema) =>
      isJointJourney && mefSchema?.jointDob?.required
        ? schema
            .required("DOB is Required")
            .test("length", "Invalid DOB", (value) => {
              const age = calcAgeFromToday(value);
              if (productId === products.GHS_IDBI) {
                return age >= 18 && age <= 71 && value.length === 10;
              }
              if (productId === PRODUCT_ID.GCS) {
                return age >= 15 && age < 66 && value?.length === 10;
              }
              if (age >= 18 && age <= 65 && value.length === 10) return true;
              return false;
            })
            .test("is-valid-date", "Invalid DOB", (value) => moment(value, "DD/MM/YYYY").isValid())
            .default("")
        : schema.notRequired()
    ),
    jointMobileNo: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointMobileNo?.required
          ? schema
              .required("Mobile Number is Required")
              .matches(regex.numeric, "Invalid Mobile Number")
              .min(10, "Min 10 digits allowed")
              .max(16, "Max 16 digits allowed")
          : schema.notRequired()
      ),
    jointPan: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointPan?.required
          ? schema.matches(regex.pancard, "Invalid PAN").max(10, "Max 10 values allowed")
          : schema
              .matches(regex.pancard, "Invalid PAN")
              .max(10, "Max 10 values allowed")
              .notRequired()
      ),
    jointGender: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointGender?.required
          ? schema.required("Gender is Required")
          : schema.notRequired()
      ),
    jointAnnualIncome: yup
      .string()
      .when(["isJointJourney"], ([isJointJourney], schema) =>
        isJointJourney && mefSchema?.jointAnnualIncome?.required
          ? schema
              .required("Annual Income is Required")
              .matches(regex.digitsWithTwoPrecisionWithoutPrecidingZero, "Invalid Annual Income")
              .min(3, "Min 3 digits required")
              .max(10, "Max 10 digits allowed")
          : schema
              .matches(regex.digitsWithTwoPrecisionWithoutPrecidingZero, "Invalid Annual Income")
              .min(3, "Min 3 digits required")
              .max(10, "Max 10 digits allowed")
              .notRequired()
      ),
    // jointRelationship: yup
    //   .string()
    //   .when("isJointJourney", ([isJointJourney], schema) =>
    //     isJointJourney ? schema.required("Relationship is required") : schema.notRequired()
    //   ),
    jointGenderCode: yup.string(),
    // jointRelationshipCode: yup.string()
    telePhoneNo: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.telePhoneNo?.required
          ? schema
              .matches(regex.numeric, "Invalid Mobile Number")
              .min(10, "Min 10 digits allowed")
              .max(16, "Max 16 digits allowed")
          : schema.notRequired()
      ),
    jointTelePhoneNo: yup
      .string()
      .when([], (_, schema) =>
        mefSchema?.jointTelePhoneNo?.required
          ? schema
              .matches(regex.numeric, "Invalid Mobile Number")
              .min(10, "Min 10 digits allowed")
              .max(16, "Max 16 digits allowed")
          : schema.notRequired()
      ),
    requirementFlag: yup.string(),
    isProportionateLife: yup.boolean(),
    primarySumAssured: yup
      .string()
      .when(["isProportionateLife"], ([isProportionateLife], schema) => {
        isProportionate = isProportionateLife;

        if (!isProportionateLife) return schema.notRequired();

        return schema
          .required("Sum Assured is required")
          .matches(regex.numeric, "Invalid Proportionate Sum Assured")
          .test(
            "amount-positive",
            "Sum Assured must be greater than 0",
            (value) => Number(value) > 0
          )
          .test(
            "sum-assured-check",
            "Total Sum Assured must not exceed Total Loan Amount Opted",
            (value, context) => {
              const form = (context as any).options.parent;
              const loan = Number(form?.totalLoanAmountOpted || 0);
              if (!loan) return true;

              // primary
              const primaryAmount = form?.primarySumAssured
                ? Number(form.primarySumAssured)
                : (Number(value || 0) / 100) * loan;

              // others
              const othersAmount = form?.proportionate?.reduce(
                (acc: number, item: { proprtionateSumAssured: any; proprtionatePercent: any }) => {
                  const amt = item?.proprtionateSumAssured
                    ? Number(item.proprtionateSumAssured)
                    : (Number(item?.proprtionatePercent || 0) / 100) * loan;
                  return acc + amt;
                },
                0
              );

              return primaryAmount + othersAmount <= loan;
            }
          );
      })
      .test(
        "check share percent",
        partnerId === partners.SREI
          ? "Loan amount cannot be below 25L per share"
          : partnerId === partners.JIO
          ? "Loan amount cannot be below 3L per share"
          : [PRODUCT_ID.GHS, PRODUCT_ID.GCS, PRODUCT_ID.GHS_IDBI].includes(productId)
          ? "Loan amount cannot be below 2L per share"
          : "Loan amount cannot be below 5L per share",
        function (value) {
          const { isProportionateLife } = this.parent;
          if (!isProportionateLife) return true;

          const primarySumAssured = Number(value || 0);

          const minLoanAmount =
            partnerId === partners.SREI
              ? VariableConstants.SREI_MIN_LOAN
              : partnerId === partners.JIO
              ? VariableConstants.JFS_MIN_LOAN
              : [PRODUCT_ID.GHS, PRODUCT_ID.GCS].includes(productId!)
              ? VariableConstants.GHS_MIN_LOAN
              : VariableConstants.BISMINLOAN;
          return primarySumAssured >= minLoanAmount;
        }
      ),
    primaryProportionatePercent: yup.string(),
    totalLoanAmountOpted: yup
      .string()
      .when(["primaryProportionatePercent"], ([primaryProportionatePercent], schema) =>
        isProportionate && mefSchema?.totalLoanAmountOpted?.required
          ? schema
              .required("Total Loan Amount Opted is Required ")
              .matches(regex.digits, "Invalid Loan Amount")
          : schema.matches(regex.digits, "Invalid Loan Amount").notRequired()
      ),
    proportionate: yup
      .array()
      .of(
        yup.object().shape({
          nameOfProportionateLife: yup
            .string()
            .when(["isProportionateLife"], (_, schema) =>
              isProportionate && mefSchema?.proportionate?.nameOfProportionateLife?.required
                ? schema
                    .required("Proportionate Name is Required")
                    .matches(regex.nomineefullNamewithDot, "Invalid Proportionate Name")
                : schema
                    .matches(regex.nomineefullNamewithDot, "Invalid Proportionate Name")
                    .notRequired()
            ),
          proprtionateDob: yup.string().when(["isProportionateLife", "mefSchema"], (_, schema) =>
            isProportionate && mefSchema?.proportionate?.proprtionateDob?.required
              ? schema
                  .required("Proportionate DOB is Required")
                  .test("length", "Invalid DOB", (value) => {
                    const age = calcAgeFromToday(value);
                    if (productId === products.GHS_IDBI) {
                      return age >= 18 && age <= 71 && value.length === 10;
                    }
                    if (productId === PRODUCT_ID.GCS) {
                      return age >= 15 && age < 66 && value?.length === 10;
                    }
                    if (age >= 18 && age <= 65 && value.length === 10) return true;
                    return false;
                  })
                  .test("is-valid-date", "Invalid DOB", (value) =>
                    moment(value, "DD/MM/YYYY").isValid()
                  )
                  .default("")
              : schema.notRequired()
          ),
          proprtionatePercent: yup.string(),
          proprtionateSumAssured: yup
            .string()
            .when("isProportionateLife", (isProportionateLife, schema) =>
              schema
                .test("required-if-proportionate", "Sum Assured is required", function (value) {
                  const { isProportionateLife } = this.parent;
                  if (!isProportionateLife) return true;

                  return !!value && String(value).trim().length > 0;
                })
                .matches(regex.numeric, "Invalid Proportionate Sum Assured")
            )

            .test(
              "sum-assured-check",
              "Total Sum Assured must not exceed Total Loan Amount Opted",
              (value: any, formikValues: any) => {
                const form = (formikValues as any).options.context;
                const loan = Number(form?.totalLoanAmountOpted || 0);
                if (!loan) return true;
                const primaryAmount = form?.primarySumAssured ? Number(form.primarySumAssured) : 0;
                const othersAmount = form?.proportionate?.reduce(
                  (
                    acc: number,
                    item: { proprtionateSumAssured: any; proprtionatePercent: any }
                  ) => {
                    const amt = item?.proprtionateSumAssured
                      ? Number(item.proprtionateSumAssured)
                      : 0;
                    return acc + amt;
                  },
                  0
                );
                return primaryAmount + othersAmount <= loan;
              }
            )
            .test(
              "check share percent",
              partnerId === partners.SREI
                ? "Loan amount cannot be below 25L per share"
                : partnerId === partners.JIO
                ? "Loan amount cannot be below 3L per share"
                : [PRODUCT_ID.GHS, PRODUCT_ID.GCS, PRODUCT_ID.GHS_IDBI].includes(productId)
                ? "Loan amount cannot be below 2L per share"
                : "Loan amount cannot be below 5L per share",
              function (value) {
                const { isProportionateLife } = this.parent;
                if (!isProportionateLife) return true;

                const primarySumAssured = Number(value || 0);

                const minLoanAmount =
                  partnerId === partners.SREI
                    ? VariableConstants.SREI_MIN_LOAN
                    : partnerId === partners.JIO
                    ? VariableConstants.JFS_MIN_LOAN
                    : [PRODUCT_ID.GHS, PRODUCT_ID.GCS].includes(productId!)
                    ? VariableConstants.GHS_MIN_LOAN
                    : VariableConstants.BISMINLOAN;
                return primarySumAssured >= minLoanAmount;
              }
            ),
          proprtionateGender: yup
            .string()
            .when(["isProportionateLife", "mefSchema"], (_, schema) =>
              isProportionate && mefSchema?.proportionate?.proprtionateGender?.required
                ? schema.required("Proportionate Gender is Required")
                : schema.notRequired()
            )
        })
      )
      .test(
        "sum-assured-final",
        "Total Sum Assured must not exceed Total Loan Amount Opted",
        function (value) {
          const form = (this as any).options.parent;
          const loan = Number(form?.totalLoanAmountOpted || 0);
          if (!loan) return true;
          const primaryAmount = form?.primarySumAssured
            ? Number(form.primarySumAssured)
            : (Number(form?.primaryProportionatePercent || 0) / 100) * loan;

          // others
          const othersAmount = form?.proportionate?.reduce(
            (acc: number, item: { proprtionateSumAssured: any; proprtionatePercent: any }) => {
              const amt = item?.proprtionateSumAssured
                ? Number(item.proprtionateSumAssured)
                : (Number(item?.proprtionatePercent || 0) / 100) * loan;
              return acc + amt;
            },
            0
          );
          return primaryAmount + othersAmount <= loan;
        }
      ),
    businessOwner: yup.boolean(),
    housewifeFlag: yup.boolean()
  });
};
export { initialValues, validationSchema };
